<template>
  <div class="search-result" style="position: absolute; z-index: 2;">
    <div class="detail-header">
      <div class="title-box">
        <h2>交易详情</h2>
        <h2 class="divider">/</h2>
       <h2 @click="$emit('switch-to-charts')" class="chart-link">图表</h2>
      </div>
    </div>

    <div class="detail-content">
      <div class="detail-card">
        <h3>商品信息</h3>
        <div class="detail-item">
          <span class="item-label">商品ID</span>
          <span class="item-value">{{ searchData.asset_info?.asset_id || '--' }}</span>
        </div>
        <div class="detail-item">
          <span class="item-label">发行时间</span>
          <span class="item-value">{{ formatDate(searchData.asset_info?.ctime) }}</span>
        </div>
        <div class="detail-item">
          <span class="item-label">发行平台</span>
          <span class="item-value">华艺链</span>
        </div>
        <div class="detail-item">
          <span class="item-label">发行量</span>
          <span class="item-value">{{ searchData.asset_info?.amount || '--' }}</span>
        </div>
        <div class="detail-item">
          <span class="item-label">流通量</span>
          <span class="item-value">{{ searchData.asset_info?.supply || '--' }}</span>
        </div>
        <div class="detail-item">
          <span class="item-label">发行状态</span>
          <span class="item-value">
            <span class="status-dot success"></span> {{ searchData.asset_info?.status === 4 ? '发行成功' : '未发行' }}
          </span>
        </div>
        <div class="detail-item">
          <span class="item-label">创作者</span>
          <span class="item-value">{{ searchData.asset_info?.create_addr || '--' }}</span>
        </div>
        <div class="detail-item">
          <span class="item-label">商品名称</span>
          <span class="item-value">{{ searchData.asset_info?.title || '--' }}</span>
        </div>
      </div>

      <div class="detail-card">
        <!-- 添加交易信息栏的标题和收起按钮 -->
        <div class="card-header" @click="toggleTransactionDetails">
          <h3>交易信息</h3>
          <span class="expand-arrow" :class="{ expanded: isTransactionExpanded }">&#9662;</span>
        </div>
        <!-- 使用v-show控制内容显示 -->
        <div class="card-content" v-show="isTransactionExpanded">
          <div class="detail-item">
            <span class="item-label">交易哈希</span>
            <span class="item-value">{{ searchData.tx_info?.hx || '--' }}</span>
          </div>
          <div class="detail-item">
            <span class="item-label">交易时间</span>
            <span class="item-value">{{ formatDate(searchData.tx_info?.[0]?.ctime) }}</span>
          </div>
          <div class="detail-item">
            <span class="item-label">商品ID</span>
            <span class="item-value">{{ searchData.tx_info?.[0]?.asset_id || '--' }}</span>
          </div>
          <div class="detail-item">
            <span class="item-label">子ID</span>
            <span class="item-value">{{ searchData.tx_info?.[0]?.sub_id || '--' }}</span>
          </div>
          <div class="detail-item">
            <span class="item-label">发行方</span>
            <span class="item-value">{{ searchData.tx_info?.[0]?.from || '--' }}</span>
          </div>
          <div class="detail-item">
            <span class="item-label">接收方</span>
            <span class="item-value">{{ searchData.tx_info?.[0]?.to || '--' }}</span>
          </div>
        </div>
      </div>

      <!-- 添加图片展示区域 -->
      <div class="image-container" ref="imageContainer">
        <img :src="searchData?.url || ''" alt="商品图片" v-if="searchData?.url" class="product-image" @click="showEnlargedImage">
      </div>
    </div>

    <!-- 图片放大模态框 -->
    <div class="image-modal" v-if="isImageEnlarged" @click="hideEnlargedImage">
      <div class="modal-content" @click.stop>
        <button class="close-btn" @click="hideEnlargedImage">×</button>
        <div class="enlarged-image-container" ref="enlargedImageContainer">
          <img :src="enlargedImageUrl" alt="放大商品图片" class="enlarged-image">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Canvas水印实现方法
function addWatermark(container, options = {}) {
  const {
    text = '水印',
    fontSize = 12,
    color = 'rgba(0, 0, 0, 0.1)',
    angle = -45,
    spacing = 100
  } = options;

  // 确保容器有正确的位置设置
  container.style.position = 'relative';

  // 创建canvas元素
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');

  // 设置canvas尺寸
  canvas.width = container.offsetWidth;
  canvas.height = container.offsetHeight;

  // 确保canvas有内容尺寸
  if (canvas.width === 0 || canvas.height === 0) {
    // 如果容器还没有尺寸，使用默认尺寸
    canvas.width = 300;
    canvas.height = 300;
  }

  // 设置水印样式
  ctx.font = `${fontSize}px 微软雅黑`;
  ctx.fillStyle = color;
  ctx.textAlign = 'center';
  ctx.textBaseline = 'middle';

  // 计算水印旋转角度（弧度）
  const radian = (angle * Math.PI) / 180;

  // 绘制重复水印
  for (let y = 0; y < canvas.height; y += spacing) {
    for (let x = 0; x < canvas.width; x += spacing) {
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(radian);
      ctx.fillText(text, 0, 0);
      ctx.restore();
    }
  }

  // 创建水印覆盖层
  const watermarkLayer = document.createElement('div');
  watermarkLayer.style.position = 'absolute';
  watermarkLayer.style.top = '0';
  watermarkLayer.style.left = '0';
  watermarkLayer.style.width = '100%';
  watermarkLayer.style.height = '100%';
  watermarkLayer.style.pointerEvents = 'none';
  watermarkLayer.style.backgroundImage = `url(${canvas.toDataURL()})`;
  watermarkLayer.style.backgroundSize = 'cover';
  watermarkLayer.style.zIndex = '9999';

  // 添加水印到容器
  container.appendChild(watermarkLayer);

  return watermarkLayer;
}

export default {
  name: 'mSearchResult',
  props: {
    searchData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isTransactionExpanded: false, // 默认收起交易信息
      isImageEnlarged: false, // 控制图片放大视图
      enlargedImageUrl: '' // 当前放大的图片URL
    }
  },
  mounted() {
    // 使用setTimeout确保DOM已完全渲染
    setTimeout(() => {
      // 使用Canvas方法添加水印到imageContainer容器
      if (this.$refs.imageContainer) {
        addWatermark(this.$refs.imageContainer, {
          text: '华艺元界',
          fontSize: 14,
          color: 'rgba(0, 0, 0, 0.2)',
          angle: -45,
          spacing: 100
        });
      }
    }, 100);
  },
  methods: {
    // 格式化日期
    formatDate(timestamp) {
      if (!timestamp) return '--'
      return new Date(Number(timestamp) * 1000).toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    },
    // 切换交易信息的展开/收起
    toggleTransactionDetails() {
      this.isTransactionExpanded = !this.isTransactionExpanded
    },
    // 显示放大的图片
    showEnlargedImage() {
      this.enlargedImageUrl = this.searchData?.url || '';
      this.isImageEnlarged = true;
      // 为放大的图片添加水印
      this.$nextTick(() => {
        if (this.$refs.enlargedImageContainer) {
          addWatermark(this.$refs.enlargedImageContainer, {
            text: '华艺元界',
            fontSize: 24,
            color: 'rgba(0, 0, 0, 0.3)',
            angle: -45,
            spacing: 150
          });
        }
      });
    },
    // 隐藏放大的图片
    hideEnlargedImage() {
      this.isImageEnlarged = false;
    }
  }
}
</script>

<style lang="less" scoped>
/* 可以从mDataview.less中复制相关样式，或者保持引用 */
@import '~@/assets/css/mDataview.less';

/* 添加交易信息栏的样式 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent; /* 移除移动端点击高亮效果 */
  outline: none; /* 移除聚焦轮廓 */
  h3 {
    margin: 0;
  }
}

.expand-arrow {
  font-size: 20px;
  color: #8C9198;
  transition: transform 0.3s;
  user-select: none;
  -webkit-tap-highlight-color: transparent; /* 移除移动端点击高亮效果 */
  outline: none; /* 移除聚焦轮廓 */
}

.expand-arrow.expanded {
  transform: rotate(180deg);
}

/* 图片展示区域样式 */
.image-container {
  width: 100%;
  height: 300px; /* 移动端适配高度 */
  background-color: #ffffff;
  background-image: url('https://hyyjs.oss-cn-beijing.aliyuncs.com/miniApp/shanshuihua.png');
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  margin-top: 20px;
  padding: 15px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  .product-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: 6;
    position: relative;
    transition: transform 0.3s ease;
  }

  &:hover .product-image {
    transform: scale(1.05);
  }
}

/* 图片放大模态框样式 */
.image-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  animation: fadeIn 0.3s ease;

  .modal-content {
    position: relative;
    max-width: 90%;
    max-height: 90%;
    animation: zoomIn 0.3s ease;

    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 28px;
      color: white;
      background-color: rgba(0, 0, 0, 0.5);
      border: none;
      border-radius: 50%;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 10000;
      -webkit-tap-highlight-color: transparent;
      outline: none;
      padding: 0;

      &:hover {
        color: #ccc;
        background-color: rgba(0, 0, 0, 0.7);
      }
    }

    .enlarged-image-container {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      max-width: 100%;
      max-height: 80vh;

      .enlarged-image {
        max-width: 100%;
        max-height: 80vh;
        object-fit: contain;
        z-index: 9998;
      }
    }
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes zoomIn {
  from { transform: scale(0.8); opacity: 0; }
  to { transform: scale(1); opacity: 1; }
}
</style>